// uses global Currency from //cdn.shopify.com/s/javascripts/currencies.js
import cookie from 'js-cookie';

import { cartModel } from '../components';

const currency = (() => {
  const CURRENCY_DEFAULT = 'USD';
  const SELECTOR_PRICE = '.js-price';
  const SELECTOR_TOGGLE = '.js-currencyDrawerToggle';
  const FORMATS = {
    USD: '$%s',
  };

  function getBrowserCurrency() {
    const currencyUnit = 'USD';
    // Add hookd here
    return currencyUnit;
  }

  function getCurrencyParam() {
    let currencyParam = null;
    const param = window.location.search.match(/currency=[a-z]{3}/);
    if (param) {
      currencyParam = param[0].replace('currency=', '').toUpperCase();
    }
    return currencyParam;
  }

  function setCurrency(currencyParam) {
    cookie.set('currency', currencyParam);
  }

  function getCurrency() {
    let currencyParam = getCurrencyParam() || cookie.get('currency') || getBrowserCurrency() || CURRENCY_DEFAULT;
    currencyParam = currencyParam.toUpperCase();
    if (!{}.hasOwnProperty.call(FORMATS, currencyParam)) {
      currencyParam = CURRENCY_DEFAULT;
    }
    setCurrency(currencyParam);
    return currencyParam;
  }

  function convert(amount, convertTo, _convertFrom) {
    const convertFrom = _convertFrom || CURRENCY_DEFAULT;
    let converted = amount;
    if (window.Currency) {
      converted = window.Currency.convert(amount, convertFrom, convertTo);
    }
    return converted;
  }

  function format(amount, currencyParam) {
    let formatted = amount;
    if ({}.hasOwnProperty.call(FORMATS, currencyParam)) {
      formatted = FORMATS[currencyParam].replace('%s', Math.ceil(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return formatted;
  }

  function renderPrice(_el, currencyParam) {
    const el = _el;
    const price = el.innerText.replace(/[^\d.]/g, '');
    const amount = parseFloat(price);
    const exchanged = convert(amount, currencyParam);
    el.innerText = format(exchanged, currencyParam);
  }

  function changeCurrency(currencyParam) {
    if (currencyParam !== CURRENCY_DEFAULT) {
      const els = document.querySelectorAll(SELECTOR_PRICE);
      if (els && els.length) {
        [].forEach.call(els, (el) => {
          renderPrice(el, currencyParam);
        });
      }
    }

    // refresh cart drawer
    cartModel.fetch();

    const togglers = document.querySelectorAll(SELECTOR_TOGGLE);
    if (togglers && togglers.length) {
      [].forEach.call(togglers, (toggler) => {
        toggler.firstChild.innerHTML = toggler.firstChild.innerHTML.replace(/(USD|KRW)/, currencyParam); // eslint-disable-line no-param-reassign
      });
    }
  }

  function init() {
    if (window.Currency) { // eslint-disable-line no-undef
      const currencyParam = getCurrency();
      changeCurrency(currencyParam);
    }
  }

  return {
    convert,
    format,
    getCurrency,
    init,
    setCurrency,
  };
})();

export default currency;
